import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]



export default /*#__PURE__*/_defineComponent({
  __name: 'BtnArea',
  props: {
    href: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "border rounded w-120px md:text-14px text-base text-center py-1",
    href: __props.href,
    target: "_blank"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})